// Plain types

// WRITE

// READ

export let AnalyticsReadNumericActionType = /*#__PURE__*/function (AnalyticsReadNumericActionType) {
  AnalyticsReadNumericActionType["Count"] = "COUNT";
  return AnalyticsReadNumericActionType;
}({});
export let AnalyticsReadNumericPropertyActionType = /*#__PURE__*/function (AnalyticsReadNumericPropertyActionType) {
  AnalyticsReadNumericPropertyActionType["Average"] = "AVERAGE";
  AnalyticsReadNumericPropertyActionType["Sum"] = "SUM";
  return AnalyticsReadNumericPropertyActionType;
}({});
export let AnalyticsReadStringPropertyActionType = /*#__PURE__*/function (AnalyticsReadStringPropertyActionType) {
  AnalyticsReadStringPropertyActionType["Unique"] = "UNIQUE";
  return AnalyticsReadStringPropertyActionType;
}({});
export let StringComparisonOperator = /*#__PURE__*/function (StringComparisonOperator) {
  StringComparisonOperator["Equal"] = "EQUAL";
  StringComparisonOperator["NotEqual"] = "NOT_EQUAL";
  StringComparisonOperator["Includes"] = "INCLUDES";
  StringComparisonOperator["NotIncludes"] = "NOT_INCLUDES";
  StringComparisonOperator["InList"] = "IN_LIST";
  StringComparisonOperator["NotInList"] = "NOT_IN_LIST";
  return StringComparisonOperator;
}({});
export let NumericComparisonOperator = /*#__PURE__*/function (NumericComparisonOperator) {
  NumericComparisonOperator["Equal"] = "EQUAL";
  NumericComparisonOperator["NotEqual"] = "NOT_EQUAL";
  NumericComparisonOperator["Gt"] = "GT";
  NumericComparisonOperator["Gte"] = "GTE";
  NumericComparisonOperator["Lt"] = "LT";
  NumericComparisonOperator["Lte"] = "LTE";
  return NumericComparisonOperator;
}({});